import axios from "axios";

const PSMZ_NOTIFICATION_PATH = "/web-app/psmz-notfications";

const SERVICE_TYPE_API_URLS: Record<string, string> = {
  delivery: "https://bot-api.regbot.bogatiykurier.ru",
  eats: "https://eats-regbot.bogatiykurier.ru",
  taxi: "https://bot-api.taxi-regbot.bogatiykurier.ru",
};

const DEFAULT_API_URL = SERVICE_TYPE_API_URLS.delivery;

export const resolvePsmzApiUrl = (serviceType: string | null) => {
  if (!serviceType) return DEFAULT_API_URL;

  return SERVICE_TYPE_API_URLS[serviceType] ?? DEFAULT_API_URL;
};

export const requestPsmzNotification = async ({
  yandexId,
  serviceType,
  hash,
}: {
  yandexId: string;
  serviceType: string | null;
  hash: string | null;
}) => {
  const { data } = await axios.get(
    `${PSMZ_NOTIFICATION_PATH}/${encodeURIComponent(yandexId)}`,
    {
      baseURL: resolvePsmzApiUrl(serviceType),
      headers: hash
        ? {
            Authorization: `Bearer ${hash}`,
          }
        : undefined,
    }
  );

  return data;
};
